// extracted by mini-css-extract-plugin
export var blocksRedirectingToResourcesTitlesContainer = "payload-module--blocks-redirecting-to-resources-titles-container--SYSzG";
export var coloredBlocksLeftPart = "payload-module--colored-blocks-left-part--FHFJW";
export var headerContactButton = "payload-module--header-contact-button--zCzm8";
export var headerInnerWrapper = "payload-module--header-inner-wrapper--no8Wj";
export var headerOuterWrapper = "payload-module--header-outer-wrapper--iTK3s";
export var headerSubtitleBorder = "payload-module--header-subtitle-border--T0sT6";
export var headerSubtitleStyles = "payload-module--header-subtitle-styles--XTJLV";
export var headerTitleContainer = "payload-module--header-title-container--GNvIT";
export var logosAndPartnersInnerWrapper = "payload-module--logos-and-partners-inner-wrapper--TpwSU";